import n from '../../../../node_modules/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".CDS_CloseButton_button__9c3b4f{flex-shrink:0}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL01vZGFsL2NvbXBvbmVudHMvQ2xvc2VCdXR0b24vQ2xvc2VCdXR0b24ubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZ0NBQ0UsYUFDRiIsInNvdXJjZXNDb250ZW50IjpbIi5idXR0b24ge1xyXG4gIGZsZXgtc2hyaW5rOiAwO1xyXG59XHJcbiJdfQ== */";
var injected = false;
var modules_0ddd42df = {get "button"() { if (!injected) { injected = true; n(css,{"prepend":true}); } return "CDS_CloseButton_button__9c3b4f"; },
inject() { if (!injected) { injected = true; n(css,{"prepend":true}); } },};

export { css, modules_0ddd42df as default };
//# sourceMappingURL=CloseButton.module.scss.js.map
